import { apiClient } from './client'

export interface Organization {
  id: string
  name: string
  slug: string
  slack_team_id: string | null
  slack_team_name: string | null
  slack_connected: boolean
  has_bot_token: boolean
  has_signing_secret: boolean
  has_client_id: boolean
  has_client_secret: boolean
  is_active: boolean
  attendance_channel_id: string | null
  leave_channel_id: string | null
  goals_channel_id: string | null
  checkin_reminders_enabled: boolean
  test_mode_enabled: boolean
  test_attendance_channel_id: string | null
  test_leave_channel_id: string | null
  test_goals_channel_id: string | null
  asset_prefix: string | null
  created_at: string
  updated_at: string
}

export interface OrganizationUpdate {
  name?: string
  slack_team_id?: string
  slack_team_name?: string
  attendance_channel_id?: string | null
  leave_channel_id?: string | null
  goals_channel_id?: string | null
  checkin_reminders_enabled?: boolean
  test_mode_enabled?: boolean
  test_attendance_channel_id?: string | null
  test_leave_channel_id?: string | null
  test_goals_channel_id?: string | null
  asset_prefix?: string | null
}

export interface SlackChannelOption {
  id: string
  name: string
  is_private: boolean
  is_member: boolean
}

export interface SlackCredentialsUpdate {
  slack_bot_token: string
  slack_signing_secret: string
  slack_client_id?: string
  slack_client_secret?: string
}

export interface SlackTestResult {
  success: boolean
  team_name: string | null
  team_id: string | null
  bot_user_id: string | null
  error: string | null
}

export async function getOrganization(): Promise<Organization> {
  const response = await apiClient.get<Organization>('/organization')
  return response.data
}

export async function updateOrganization(data: OrganizationUpdate): Promise<Organization> {
  const response = await apiClient.put<Organization>('/organization', data)
  return response.data
}

export async function updateSlackCredentials(data: SlackCredentialsUpdate): Promise<Organization> {
  const response = await apiClient.put<Organization>('/organization/slack-credentials', data)
  return response.data
}

export async function removeSlackCredentials(): Promise<void> {
  await apiClient.delete('/organization/slack-credentials')
}

export async function testSlackConnection(): Promise<SlackTestResult> {
  const response = await apiClient.post<SlackTestResult>('/organization/slack-credentials/test')
  return response.data
}

export async function listSlackChannels(): Promise<SlackChannelOption[]> {
  const response = await apiClient.get<SlackChannelOption[]>('/organization/slack-channels')
  return response.data
}

export async function getSlackInstallUrl(): Promise<{ url: string }> {
  const response = await apiClient.get<{ url: string }>('/organization/slack/install-url')
  return response.data
}

export async function completeSlackInstall(code: string, state: string): Promise<Organization> {
  const response = await apiClient.post<Organization>('/organization/slack/install-callback', { code, state })
  return response.data
}
